import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Input, Button, Card, Select, Checkbox, Spin,
} from 'antd';
import { statics } from './statics';
import { filterSearchRequest } from '../redux/actions/filter_search.actions';
import { searchByBrandRequest } from '../redux/actions/search_by_brand.actions';
import { searchBikeModelRequest } from '../redux/actions/search_bike_model.actions';
import { searchHCRequest } from '../redux/actions/search_hc.actions';
// import { history } from '../../../../config/history';
import {
    searchBikeBrandRequest, searchBikeModelsRequest, searchBikesRequest, setBikeManagementFilter,
} from '../redux/actions/search_bikes.actions';
import { debounce } from '../../../../shared/helpers';


const { Option } = Select;
const checkboxStylingFirst = { fontSize: '14px', margin: '0 0 5% 8px' };
const checkboxStyling = { fontSize: '14px', marginBottom: '5%' };
const advancedSearchStyle = { cursor: 'pointer', fontWeight: 600 };
const optionsStyling = { marginRight: 20, fontWeight: 500, cursor: 'pointer' };

class BikeAdvancedSearch extends Component {
    goToSimpleSearch = () => this.props.dispatch({ type: 'SWITCH_SEARCH', payload: false });

    filterBikes = (key, value) => this.props.dispatch(filterSearchRequest({ ...this.props.where, [key]: value === 0 ? undefined : value }));

    filterBikesByBrand = event => this.props.dispatch(searchByBrandRequest(event.target.value));

    filterBikesByModel = event => this.props.dispatch(searchBikeModelRequest(event.target.value));

    showTable = () => this.props.dispatch({ type: 'SHOW_TABLE', payload: true });

    setButtonStatus = ({ amount, searchedData }) => {
        switch (amount) {
        case 0:
            return null;
        case 1:
            return () => {};
            // history.push(`/PlatformManagement/Bike_model_update/${searchedData[0]._id}`);
        default:
            return this.showTable;
        }
    };

    filterByHC = (key, value) => this.props.dispatch(searchHCRequest({ ...this.props.where, [key]: value }));

    resetFilters = () => {
        this.props.dispatch({ type: 'RESET_ALL_FILTERS' });
        this.props.dispatch(filterSearchRequest({}));
    };

    refreshFilters = () => this.props.dispatch(filterSearchRequest({ ...this.props.where }));

    styles = {
        filter_container: {
            display: 'flex',
            justifyContent: 'space-between',
            flexFlow: 'row wrap',
            width: '100%',
        },
        filters_wrapper: {
            width: '33%',
            maxWidth: 450,
            minWidth: 300,
            display: 'flex',
            flexDirection: 'column',
        },
        filter: {
            width: '100%',
            marginBottom: 25,
        },
    };

    searchBikesReq = () => {
        /* list of possible params:
            ref_bike_brand:
                {
                    _id: "MongoID",
                    // name: String,
                },
                ref_bike_model:
                {
                    _id: "MongoID",
                    $and: [],
                    // name: String,
                    // alternative_names: [],

                    // bike_type: String,
                    // cc: Number,
                    // mileage_limit: Number,
                    // min_age: Number,
                    // always_manual_price: Boolean,
                    // check_race_replica: Boolean,
                    // we_dont_want: Boolean,
                    // check_luggage: Boolean,
                    // leadomatic_priority: Number,
                    // wwym_priority: Number,
                },
                ref_bike_variant:
                {
                    _id: "MongoID",
                    // name: String,
                    // is_hot: Boolean,
                    // is_no_buy: Boolean,

                    $and: [],
                }

                skip(offset)
                limit(start from)
                method(count if needed to count all found bikes by criteria)
         */
        const params = {
            filters: {
                // ref_bike_brand: "5bc9b3e40446ac02af51a5cc",
                ref_bike_model: {
                    _id: '5bc9b59b0446ac02af51ae5d',
                },
            },
        };

        this.props.dispatch(searchBikesRequest(params));
    };

    searchBikeBrand = value => this.props.dispatch(searchBikeBrandRequest(value));

    debouncedSearchBikeBrand = debounce(this.searchBikeBrand, 500);

    handleBikeBrandSearch = value => this.debouncedSearchBikeBrand(value);

    // models_data
    handleBikeBrandChange = (value) => {
        this.props.dispatch(setBikeManagementFilter({ db_key: 'ref_bike_brand', value }));
    };

    searchBikeModels = value => this.props.dispatch(searchBikeModelsRequest(value, this.props.filters.ref_bike_brand.value));

    debouncedSearchBikeModels = debounce(this.searchBikeModels, 500);

    handleBikeModelsSearch = value => this.debouncedSearchBikeModels(value);

    // models_data
    handleBikeModelsChange = (value) => {
        this.props.dispatch(setBikeManagementFilter({ db_key: 'ref_bike_model', value }));
    };

    handleFiltersChange = (val, db_key) => this.props.dispatch(setBikeManagementFilter({ db_key, value: val }));


    render() {
        return (
            <Fragment>
                <Card className="border-shadows" style={{ paddingTop: '10px' }}>
                    <div style={this.styles.filter_container}>
                        <div style={this.styles.filters_wrapper}>
                            <Select
                                style={this.styles.filter}
                                showSearch
                                allowClear
                                placeholder="Make"
                                onSearch={this.handleBikeBrandSearch}
                                filterOption={false}
                                onChange={this.handleBikeBrandChange}
                                value={this.props.filters.ref_bike_brand.value}
                            >
                                {this.props.brands_data && this.props.brands_data.map(brand => <Select.Option key={brand._id} value={brand._id}>{brand.name}</Select.Option>)}
                            </Select>
                            <Select
                                style={this.styles.filter}
                                showSearch
                                allowClear
                                placeholder="Model"
                                onSearch={this.handleBikeModelsSearch}
                                filterOption={false}
                                onChange={this.handleBikeModelsChange}
                                value={this.props.filters.ref_bike_model.value}
                            >
                                {this.props.models_data && this.props.models_data.map(brand => <Select.Option key={brand._id} value={brand._id}>{brand.name}</Select.Option>)}
                            </Select>
                            <Input
                                type="number"
                                style={this.styles.filter}
                                allowClear
                                value={this.props.filters.cc.value}
                                placeholder="Approximate Engine Size"
                                onChange={({ target: { value } }) => this.handleFiltersChange(value, 'cc')}
                            />

                            <Select
                                style={this.styles.filter}
                                allowClear
                                value={this.props.filters.bike_type.value}
                                placeholder="Bike Type"
                                onChange={value => this.handleFiltersChange(value, 'bike_type')}
                            >
                                {statics.bike_types.map(pr => <Option key={pr}>{pr}</Option>)}
                            </Select>
                        </div>


                        <div style={this.styles.filters_wrapper}>
                            <Select
                                style={this.styles.filter}
                                allowClear
                                value={this.props.filters.mileage_limit.value}
                                placeholder="Mileage Limit"
                                onChange={value => this.handleFiltersChange(value, 'mileage_limit')}
                            >
                                {statics.bike_mileage_limit.map(limit => <Option key={limit.value}>{limit.label}</Option>)}
                            </Select>
                            <Select
                                style={this.styles.filter}
                                allowClear
                                value={this.props.filters.min_age.value}
                                placeholder="Minimum Age"
                                onChange={value => this.handleFiltersChange(value, 'min_age')}
                            >
                                {statics.bike_min_age.map(age => <Option key={age.value}>{age.label}</Option>)}
                            </Select>
                            <Select
                                style={this.styles.filter}
                                allowClear
                                value={this.props.filters.wwym_priority.value}
                                placeholder="We Want Priority"
                                onChange={value => this.handleFiltersChange(value, 'wwym_priority')}
                            >
                                {statics.bike_priorities.map(pr => <Option key={pr.value}>{pr.label}</Option>)}
                            </Select>
                            <Select
                                style={this.styles.filter}
                                allowClear
                                value={this.props.filters.leadomatic_priority.value}
                                placeholder="Leadomatic Priority"
                                onChange={value => this.handleFiltersChange(value, 'leadomatic_priority')}
                            >
                                {statics.bike_priorities.map(pr => <Option key={pr.value}>{pr.label}</Option>)}
                            </Select>
                        </div>


                        <div style={this.styles.filters_wrapper}>
                            <Checkbox checked={this.props.filters.check_luggage.value} style={checkboxStylingFirst} onChange={({ target: { checked } }) => this.handleFiltersChange(checked, 'check_luggage')}>Only Bikes with Luggage</Checkbox>
                            <Checkbox checked={this.props.filters.always_manual_price.value} style={checkboxStyling} onChange={({ target: { checked } }) => this.handleFiltersChange(checked, 'always_manual_price')}>Only Bikes that have Manual Price Check</Checkbox>
                            <Checkbox checked={this.props.filters.check_race_replica.value} style={checkboxStyling} onChange={({ target: { checked } }) => this.handleFiltersChange(checked, 'check_race_replica')}>Only Bikes that are Race Replicas</Checkbox>
                            <Checkbox checked={this.props.filters.we_dont_want.value} style={checkboxStyling} onChange={({ target: { checked } }) => this.handleFiltersChange(checked, 'we_dont_want')}>Only Bikes 'We Dont Want'</Checkbox>
                            <Checkbox checked={this.props.filters.is_duplicate.value} style={checkboxStyling} onChange={({ target: { checked } }) => this.handleFiltersChange(checked, 'is_duplicate')}>Only Duplicate Bikes</Checkbox>
                            <Checkbox checked={this.props.filters.is_hot.value} style={checkboxStyling} onChange={({ target: { checked } }) => this.handleFiltersChange(checked, 'is_hot')}>Only Bikes on the 'Hot List'</Checkbox>
                            <Checkbox checked={this.props.filters.is_no_buy.value} style={checkboxStyling} onChange={({ target: { checked } }) => this.handleFiltersChange(checked, 'is_no_buy')}>Only Bikes on the 'Cold List'</Checkbox>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                        <p style={advancedSearchStyle} onClick={this.goToSimpleSearch}>Hide Advanced Search</p>
                        <div>
                            <Spin style={{ marginRight: 10 }} spinning={this.props.loading} size="small" />
                            <Button type="primary" style={optionsStyling} onClick={this.searchBikesReq}>Search</Button>

                            <Button disabled={this.props.amount === 0 || this.props.amount === '0'} onClick={this.showTable}>
                                {this.props.amount !== 0 ? `Found ${this.props.amount} bikes, see results` : `Found ${this.props.amount} bikes`}
                            </Button>
                        </div>
                    </div>
                </Card>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    searchedData: state.PlatformManagement.Bike_management.searchedData,
    loading: state.PlatformManagement.Bike_management.loading,
    amount: state.PlatformManagement.Bike_management.amount,
    where: state.PlatformManagement.Bike_management.where,
    pagination: state.PlatformManagement.Bike_management.pagination,
    brands_data: state.PlatformManagement.Bike_management.brands_data,
    models_data: state.PlatformManagement.Bike_management.models_data,
    brand_id: state.PlatformManagement.Bike_management.brand_id,
    model_id: state.PlatformManagement.Bike_management.model_id,
    filters: state.PlatformManagement.Bike_management.filters,
});

export default connect(mapStateToProps)(BikeAdvancedSearch);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/components/BikeAdvancedSearch.js